export const getFirstDigitOfNumber = ({ num }) => {
  while (num > 9) {
    num /= 10;
  }
  return parseInt(num);
};

export const applyEncodingToValues = ({ value, firstDigitOfUserId }) => {
  let result = '';
  for (let index = 0; index < value.length; index += 1) {
    const enc = Number(value[index]) + firstDigitOfUserId;
    const lastDigit = enc.toString().slice(-1);
    result += lastDigit.toString();
  }
  return result;
};

export const convertUtcToEst = (inputDate, options = {}) => {
  if (!inputDate) return null;

  let utcDate;

  if (typeof inputDate === 'string') {
    utcDate = new Date(inputDate.endsWith('Z') ? inputDate : inputDate + 'Z');
  } else if (inputDate instanceof Date) {
    utcDate = new Date(inputDate.toISOString());
  } else {
    throw new Error('Invalid date input');
  }

  const formatOptions = {
    timeZone: 'America/New_York',
    ...options,
  };

  return new Intl.DateTimeFormat('en-US', formatOptions).format(utcDate);
};

